import { useMemo, useRef } from 'react';
import { noop } from '@helpers/misc';
import { AppFCC } from '@types';
import { Closer } from '@kit/closer';
import { Overlay } from '@kit/overlay';
import { DropdownBodyStyled, dropdownOverlayClassName, DropdownStyled, DropdownTriggerStyled } from './styled';
import { DropdownProps, DropdownRefElement } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export const Dropdown: AppFCC<DropdownProps> = props => {
  const {
    rootRef: originRootRef,
    bodyClassName,
    position,
    offsetTop,
    offsetBottom,
    offsetLeft,
    minWidth,
    maxWidth,
    withOverlay,
    children,
    renderDropdown,
    opened,
    disabled,
    onOpen,
    onClose
  } = props;
  const _rootRef = useRef<DropdownRefElement>(null);
  const rootRef = useMemo(() => originRootRef ?? _rootRef,
  //
  [originRootRef]);
  return _jsxs(DropdownStyled, {
    ref: rootRef,
    children: [!opened ? null : _jsxs(Closer //
    , {
      rootRef: rootRef,
      onClose: onClose,
      children: [!withOverlay ? null : _jsx(Overlay //
      , {
        className: dropdownOverlayClassName,
        onClick: onClose
      }), _jsx(DropdownBodyStyled, {
        className: bodyClassName,
        position: position,
        style: {
          minWidth,
          maxWidth,
          marginTop: offsetTop,
          marginBottom: offsetBottom,
          marginLeft: offsetLeft
        },
        children: renderDropdown(onClose)
      })]
    }), _jsx(DropdownTriggerStyled //
    , {
      role: "button",
      tabIndex: -1,
      disabled: disabled,
      onClick: onOpen,
      onKeyDown: noop,
      children: children
    })]
  });
};